import { axios } from '../services/axios';
import { CHANGE_PASSWORD_API, USER_DETAILS_API, CHECK_EMAIL_EXIST, CHANGE_SIGNATURE, MACHINE_LIST_API ,SUB_USER_LIST,ADD_SUB_USER,DELETE_SUB_USER, MACHINE_LIST_WITH_INPROGRESS_API} from '../constants/paths';

/**
 * ChangePassword DTO
 * @export
 * @typedef {ChangePasswordDTO}
 */
export type ChangePasswordDTO = {
    userId: string;
    currentPassword: string;
    password: string;
};

/**
 * ChangePassword API Call
 * @param {ChangePasswordDTO} data
 * @returns {Promise<any>}
 */
export const changePassword = (data: ChangePasswordDTO): Promise<any> => {
    return axios.post(CHANGE_PASSWORD_API, data);
};



/**
 * UserDetailsDTO DTO
 * @export
 * @typedef {UserDetailsDTO}
 */
export type UserDetailsDTO = {
    userId: string;
};

/**
 * ChangePassword API Call
 * @param {UserDetailsDTO} data
 * @returns {Promise<any>}
 */
export const getUserDetails = (data: UserDetailsDTO): Promise<any> => {
    return axios.post(USER_DETAILS_API, data);
};

/**
 * Machine List API Call
 * @param {UserDetailsDTO} data
 * @returns {Promise<any>}
 */
export const getMachineList = (data: UserDetailsDTO): Promise<any> => {
    return axios.post(MACHINE_LIST_API, data);
};

/**
 * Machine List API Call
 * @param {UserDetailsDTO} data
 * @returns {Promise<any>}
 */
export const getMachineListWithInprogress = (data: UserDetailsDTO): Promise<any> => {
  return axios.post(MACHINE_LIST_WITH_INPROGRESS_API, data);
};



/**
 * Checkemailexists DTO
 * @export
 * @typedef {CheckEmailExistDTO}
 */
export type CheckEmailExistDTO = {
    email: string;
};

/**
 * Forgot Password API Call
 * @param {CheckEmailExistDTO} data
 * @returns {Promise<any>}
 */
export const checkEmailExist = (data: CheckEmailExistDTO): Promise<any> => {
    return axios.post(CHECK_EMAIL_EXIST, data);
};

/**
 * Checkemailexists DTO
 * @export
 * @typedef {ChangeSignatureDTO}
 */
export type ChangeSignatureDTO = {
    signature: string;
    userId: string;
};

/**
 * Forgot Password API Call
 * @param {ChangeSignatureDTO} data
 * @returns {Promise<any>}
 */
export const changeSignature = (data: ChangeSignatureDTO): Promise<any> => {
    return axios.post(CHANGE_SIGNATURE, data);
};


/**
 * Sub user list for logedin user
 * @param  userId
 * @returns {Promise<any>}
 */

/**
 * sub user DTO
 * @export
 * @typedef {subUserDTO}
 */
export type subUserDTO = {
    sortColumn: string;
    sortDirection: string;
};
export const subUsersApiCall = (
    data: subUserDTO,
    userId: number
  ): Promise<any> => {
    return axios.get(`${SUB_USER_LIST}/${userId}`, {
      params: data,
    });
  };

/**
 * add sub user DTO
 * @export
 * @typedef {addUserDTO}
 */
export type addUserDTO = {
    first_name: string;
    last_name: string;
    parent_id : number;
    company_name : string;
    email: string;
    phone: number;
    designation: string;

};
  

export const addSubUserApiCall = (
    data: addUserDTO,
   
  ): Promise<any> => {
    return axios.post(`${ADD_SUB_USER}`, data);
  };



  export const userDeleteApiCall = (
    user_id: number,
  ): Promise<any> => {
    return axios.delete(`${DELETE_SUB_USER}/${user_id}`);
  };

  